import { NetworkErrorCode, WsNetworkError } from '@gem/modules/wsClient/wsErrors';
import { WsDisconnectCode, WsController, WsNetworkService } from '@gem/modules/wsClient/wsServices';

export class WsCallsApiController {
  private token: string;
  private ws: WsController;
  private channelId: string;
  private refreshTokenFn: (() => Promise<string | null>) | null = null;

  constructor(private networkService: WsNetworkService, private url: string) {
    this.ws = new WsController(networkService);
    this.ws.onClose((event: CloseEvent) => this.handleWsClose(event));
  }

  public connect(token: string, url: string, channelId: string): void {
    this.url = url;
    this.channelId = channelId;
    this.token = token;

    this.ws.connect(
      `${this.url}/calls/${this.channelId}/connect?token=${this.token}`,
      'arraybuffer'
    );
  }

  public set refreshToken(refreshTokenFn: () => Promise<string | null>) {
    this.refreshTokenFn = refreshTokenFn;
  }

  public disconnect(code?: WsDisconnectCode, reason?: string): void {
    if (reason) {
      const error = new WsNetworkError(NetworkErrorCode.Unauthorized, reason);
      this.networkService.error(error);
    }
    this.ws.disconnect(code);
  }

  private async handleWsClose(event: CloseEvent): Promise<void> {
    if (event.code === WsDisconnectCode.TokenExpired) {
      const token = this.refreshTokenFn ? await this.refreshTokenFn() : null;

      if (token) {
        this.connect(token, this.url, this.channelId);
      } else {
        this.disconnect(event.code, event.reason);
      }
    }
    if (event.code === WsDisconnectCode.UnexpectedError) {
      this.connect(this.token, this.url, this.channelId);
    }
  }
}
